import { IStatistics } from '../../types';

export enum statsAcionType {
  UPDATE_USER_STATS = 'UPDATE_USER_STATS',
  UPDATE_USER_STATS_SUCCESS = 'UPDATE_USER_STATS_SUCCESS',
  QQ = 'QQ',
}

interface updateUserStatsAction {
  type: statsAcionType.UPDATE_USER_STATS;
}
interface updateUserStatsActionSuccess {
  type: statsAcionType.UPDATE_USER_STATS_SUCCESS;
  payload: IStatistics;
}
interface updateUserStatsActionSuccess {
  type: statsAcionType.UPDATE_USER_STATS_SUCCESS;
  payload: IStatistics;
}
interface qq {
  type: statsAcionType.QQ;
}
export type StatsAction = updateUserStatsAction | updateUserStatsActionSuccess | qq;

export enum StatisticsOption {
  TEXTBOOK = 'textbook',
  SPRINT = 'sprint',
  AUDIO = 'audio',
}
